import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const NinetyTwoToOneTwoTwo = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>92</Td>
          <Td>โยชูวา 4,5</Td>
          <Td>โรม 10</Td>
          <Td>Joshua 4,5</Td>
          <Td>Romans 10</Td>
          <Td>เพื่อเป็นที่ระลึก</Td>
        </tr>
        <tr>
          <Td>93</Td>
          <Td>โยชูวา 6,7</Td>
          <Td>โรม 11</Td>
          <Td>Joshua 6,7</Td>
          <Td>Romans 11</Td>
          <Td>ไม่มีอะไรที่เป็นไปไม่ได้</Td>
        </tr>
        <tr>
          <Td>94</Td>
          <Td>โยชูวา 8,9</Td>
          <Td>โรม 12</Td>
          <Td>Joshua 8,9</Td>
          <Td>Romans 12</Td>
          <Td>ชัยชนะ-เป็นของคุณแล้ว</Td>
        </tr>
        <tr>
          <Td>95</Td>
          <Td>โยชูวา 10,11</Td>
          <Td>สดุดี 38</Td>
          <Td>Joshua 10,11</Td>
          <Td>Psalms 38</Td>

          <Td>คำร้องขอความช่วยเหลือ</Td>
        </tr>
        <tr>
          <Td>96</Td>
          <Td>โยชูวา 12-15</Td>
          <Td>โรม 13</Td>
          <Td>Joshua 12-15</Td>
          <Td>Romans 13</Td>

          <Td>พลเมือง-กับความรับผิดชอบ</Td>
        </tr>
        <tr>
          <Td>97</Td>
          <Td>โยชูวา 16-19</Td>
          <Td>โรม 14</Td>
          <Td>Joshua 16-19</Td>
          <Td>Romans 14</Td>

          <Td>ต้องคิดถึงคนอื่นด้วย</Td>
        </tr>
        <tr>
          <Td>98</Td>
          <Td>โยชูวา 20-22</Td>
          <Td>สดุดี 39</Td>
          <Td>Joshua 20-22</Td>
          <Td>Psalms 39</Td>
          <Td>ที่ลี้ภัย</Td>
        </tr>
        <tr>
          <Td>99</Td>
          <Td>โยชูวา 23,24</Td>
          <Td>โรม 15</Td>
          <Td>Joshua 23,24</Td>
          <Td>Romans 15</Td>
          <Td>อยู่เคียงข้างคุณ</Td>
        </tr>
        <tr>
          <Td>100</Td>
          <Td>ผู้วินิจฉัย 1,2</Td>
          <Td>โรม 16</Td>
          <Td>Judges 1,2</Td>
          <Td>Romans 16</Td>

          <Td>รวมกันเราอยู่</Td>
        </tr>
        <tr>
          <Td>101</Td>
          <Td>ผู้วินิจฉัย 3,4</Td>
          <Td>มาระโก 1</Td>
          <Td>Judges 3,4</Td>
          <Td>Mark 1</Td>
          <Td>พระเจ้าทรงประทาน</Td>
        </tr>
        <tr>
          <Td>102</Td>
          <Td>ผู้วินิจฉัย 5,6</Td>
          <Td>สดุดี 40,41</Td>
          <Td>Judges 5,6</Td>
          <Td>Psalms 40,41</Td>
          <Td>ปลอดภัย</Td>
        </tr>
        <tr>
          <Td>103</Td>
          <Td>ผู้วินิจฉัย 7,8</Td>
          <Td>มาระโก 2</Td>
          <Td>Judges 7,8</Td>
          <Td>Mark 2</Td>
          <Td>ทดสอบความเชื่อ</Td>
        </tr>
        <tr>
          <Td>104</Td>
          <Td>ผู้วินิจฉัย 9,10</Td>
          <Td>มาระโก 3</Td>
          <Td>Judges 9,10</Td>
          <Td>Mark 3</Td>

          <Td>ตามผู้นำ</Td>
        </tr>
        <tr>
          <Td>105</Td>
          <Td>ผู้วินิจฉัย 11,12</Td>
          <Td>สดุดี 42,43</Td>
          <Td>Judges 11,12</Td>
          <Td>Psalms 42,43</Td>

          <Td>ความช่วยเหลือมีพร้อม</Td>
        </tr>
        <tr>
          <Td>106</Td>
          <Td>ผู้วินิจฉัย 13,14</Td>
          <Td>มาระโก 4</Td>
          <Td>Judges 13,14</Td>
          <Td>Mark 4</Td>
          <Td>เคล็ดลับของพลัง</Td>
        </tr>
        <tr>
          <Td>107</Td>
          <Td>ผู้วินิจฉัย 15,16</Td>
          <Td>มาระโก 5</Td>
          <Td>Judges 15,16</Td>
          <Td>Mark 5</Td>
          <Td>ปล่อยพลัง</Td>
        </tr>
        <tr>
          <Td>108</Td>
          <Td>ผู้วินิจฉัย 17,18</Td>
          <Td>มาระโก 6</Td>
          <Td>Judges 17,18</Td>
          <Td>Mark 6</Td>
          <Td>น่าประหลาดใจ-แต่จริง</Td>
        </tr>
        <tr>
          <Td>109</Td>
          <Td>ผู้วินิจฉัย 19,20</Td>
          <Td>สดุดี 44</Td>
          <Td>Judges 19,20</Td>
          <Td>Psalms 44</Td>
          <Td>ยากที่จะเข้าใจ</Td>
        </tr>
        <tr>
          <Td>110</Td>
          <Td>ผู้วินิจฉัย 21</Td>
          <Td>มาระโก 7</Td>
          <Td>Judges 21</Td>
          <Td>Mark 7</Td>

          <Td>วนเวียนอยู่กับปัญหา</Td>
        </tr>
        <tr>
          <Td>111</Td>
          <Td>นางรูธ 1,2</Td>
          <Td>มาระโก 8</Td>
          <Td>Ruth 1,2</Td>
          <Td>Mark 8</Td>

          <Td>การแสดงออกถึงความรัก</Td>
        </tr>
        <tr>
          <Td>112</Td>
          <Td>นางรูธ 3,4</Td>
          <Td>สดุดี 45</Td>
          <Td>Ruth 3,4</Td>
          <Td>Psalms 45</Td>

          <Td>ทรงจัดเตรียมความสุขให้เรา</Td>
        </tr>
        <tr>
          <Td>113</Td>
          <Td>1 ซามูเอล 1-3</Td>
          <Td>มาระโก 9</Td>
          <Td>1 Samuel 1-3</Td>
          <Td>Mark 9</Td>

          <Td>เป็นที่พอพระทัยพระเจ้า</Td>
        </tr>
        <tr>
          <Td>114</Td>
          <Td>1 ซามูเอล 4-6</Td>
          <Td>มาระโก 10</Td>
          <Td>1 Samuel 4-6</Td>
          <Td>Mark 10</Td>

          <Td>ใครช่วยเราให้รอดได้?</Td>
        </tr>
        <tr>
          <Td>115</Td>
          <Td>1 ซามูเอล 7-9</Td>
          <Td>มาระโก 11</Td>
          <Td>1 Samuel 7-9</Td>
          <Td>Mark 11</Td>

          <Td>ใครเป็นกษัตริย์?</Td>
        </tr>
        <tr>
          <Td>116</Td>
          <Td>1 ซามูเอล 10,11</Td>
          <Td>สดุดี 46,47</Td>
          <Td>1 Samuel 10,11</Td>
          <Td>Psalms 46,47</Td>

          <Td>เวลาแห่งความยินดี</Td>
        </tr>
        <tr>
          <Td>117</Td>
          <Td>1 ซามูเอล 12,13</Td>
          <Td>มาระโก 12</Td>
          <Td>1 Samuel 12,13</Td>
          <Td>Mark 12</Td>

          <Td>ตัดสินตัวเอง</Td>
        </tr>
        <tr>
          <Td>118</Td>
          <Td>1 ซามูเอล 14,15</Td>
          <Td>มาระโก 13</Td>
          <Td>1 Samuel 14,15</Td>
          <Td>Mark 13</Td>

          <Td>เดือดร้อนและสับสน</Td>
        </tr>
        <tr>
          <Td>119</Td>
          <Td>1 ซามูเอล 16,17</Td>
          <Td>สดุดี 48</Td>
          <Td>1 Samuel 16,17</Td>
          <Td>Psalms 48</Td>

          <Td>ปลอดภัยในพระองค์</Td>
        </tr>
        <tr>
          <Td>120</Td>
          <Td>1 ซามูเอล 18,19</Td>
          <Td>มาระโก 14</Td>
          <Td>1 Samuel 18,19</Td>
          <Td>Mark 14</Td>

          <Td>รักอะไรจะปานนั้น</Td>
        </tr>
        <tr>
          <Td>121</Td>
          <Td>1 ซามูเอล 20-22</Td>
          <Td>มาระโก 15</Td>
          <Td>1 Samuel 20-22</Td>
          <Td>Mark 15</Td>

          <Td>โทษถึงตาย</Td>
        </tr>
        <tr>
          <Td>122</Td>
          <Td>1 ซามูเอล 23,24</Td>
          <Td>มาระโก 16</Td>
          <Td>1 Samuel 23,24</Td>
          <Td>Mark 16</Td>

          <Td>ชีวิตในพระหัตถ์ของพระเจ้า</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default NinetyTwoToOneTwoTwo;
